// Lógica pura de «la mesa se cerró en otro dispositivo» (sin imports: la
// usa tpvResume, que no debe arrastrar Redux/axios). Ver selectedMesaClosed.js.

export const validId = (id) => id != null && id !== -1 && id !== "-1" && id !== "";
export const sameId = (a, b) => validId(a) && validId(b) && String(a) === String(b);

export const mesaLabelOf = (mesa) => {
  const label = String(mesa?.nombre || mesa?.id_mesa || "").trim();
  return /^\d+$/.test(label) ? `Mesa ${label}` : label || "La mesa";
};

/** Líneas sin enviar (ni comandadas ni servidas) del carrito y del borrador de la mesa. */
export function unsentLinesOf(cart = [], draftCart = []) {
  return [...(cart || []), ...(draftCart || [])].filter((l) => l && !l.old && !l.servido && Number(l.quantity) > 0);
}

/** «2× Caña, 1× Tortilla» (agrupa por nombre; máx. 4 y «y N más»). */
export function summarizeLines(lines = []) {
  const byName = new Map();
  lines.forEach((l) => {
    const name = String(l.nombre || l.name || "Producto").trim();
    byName.set(name, (byName.get(name) || 0) + (Number(l.quantity) || 0));
  });
  const parts = [...byName.entries()].map(([n, q]) => `${q}× ${n}`);
  return parts.length > 4 ? `${parts.slice(0, 4).join(", ")} y ${parts.length - 4} más` : parts.join(", ");
}

/** Texto del aviso (puro). */
export function closedElsewhereMessage(mesa, unsentLines = []) {
  // Libre puede ser cobrada, cerrada o movida a otra mesa: no lo afirmamos.
  const base = `${mesaLabelOf(mesa)} ya no tiene cuenta abierta: se cobró, se cerró o se movió desde otro dispositivo`;
  const list = Array.isArray(unsentLines) ? summarizeLines(unsentLines) : "";
  // Lo no enviado NO se guarda: la mesa queda libre para los siguientes
  // clientes y no deben aparecerles productos de la cuenta anterior.
  return list ? `${base}. No se llegaron a enviar y se han descartado: ${list}.` : `${base}.`;
}

/**
 * Antes de la vuelta: ¿la mesa seleccionada tenía cuenta abierta? Solo así
 * «ahora está libre» significa «la cerraron en otro sitio» (una mesa libre
 * recién elegida sin abrir sigue libre y no se toca).
 */
export function selectedMesaSnapshot(state) {
  const id = state?.mesas?.selectedId;
  if (!validId(id)) return null;
  const mesa = (state?.mesas?.mesas || []).find((m) => sameId(m?.id, id));
  const sessionId = state?.session?.session?.id;
  return { mesaId: id, wasOpen: mesa?.ocupada === true || !!sessionId };
}

/** Tras refrescar: ¿hay que sacar al camarero de la mesa? (puro) */
export function shouldLeaveClosedMesa(before, state) {
  if (!before?.wasOpen) return false;
  if (!sameId(state?.mesas?.selectedId, before.mesaId)) return false; // ya salió / cambió de mesa
  const mesa = (state?.mesas?.mesas || []).find((m) => sameId(m?.id, before.mesaId));
  return mesa?.ocupada === false;
}
